{
  "pointsBalance": {
    "noPointsMainText": "Avios on kanta-asiakasvaluuttamme. Kerää tai osta Avioksia ja astu lukemattomien etujen maailmaan.",
    "noPointsFooterText": "Aviokset vanhenevat, jos sinulla ei ole tilitapahtumia 18:aan kuukauteen.",
    "collectAvios": "Näin keräät Avioksia"
  }
}
